<div class="dashboard-container">
  <header class="dashboard-header">
    <h1>Quotes Overview</h1>
  </header>

  <main class="dashboard-main-content">
    <section class="quote-overview-summary">
      <div class="summary-card">
        <h3>Total Quotes</h3>
        <p class="metric-value">10</p>
      </div>
      <div class="summary-card">
        <h3>Quotes in Progress</h3>
        <p class="metric-value status-inprogress">2</p>
      </div>
      <div class="summary-card">
        <h3>Pending Approval</h3>
        <p class="metric-value status-pending">6</p>
      </div>
      <div class="summary-card">
        <h3>Quotes Won (YTD)</h3>
        <p class="metric-value status-won">2</p>
      </div>
    </section>

    <section class="recent-quotes-list">
      <h2>Recent Quotes</h2>
      <div class="list-container">
        <table>
          <thead>
            <tr>
              <th>Quote Ref</th>
              <th>Customer</th>
              <th>Value</th>
              <th>Created By</th>
              <th>Type</th>
              <th>Status</th>
              <th>Quote Date</th>
            </tr>
          </thead>
          <tbody>
            @for (quote of data; track quote.quote_id) {
              <tr class="quote-item">
                <td>
                  <a
                    class="quote-reference"
                    [routerLink]="quote_link(quote.quote_id, quote.quote_type)"
                    >{{ quote.quote_ref }}</a
                  >
                </td>
                <td>{{ quote.customer_name }}</td>
                <td>
                  {{
                    quote.total_price || quote.service_total || "0.00"
                      | currency: "GBP"
                  }}
                </td>
                <td>{{ quote.full_name }}</td>
                <td>{{ getQuoteTypeName(quote.quote_type) }}</td>
                <td [class]="'status-' + quote.quote_status">
                  {{ quote.quote_status | titlecase }}
                </td>
                <td>{{ quote.dtm_quote }}</td>
              </tr>
            }
          </tbody>
        </table>
        <div class="list-footer">
          <a routerLink="/quotes" class="view-all-link"
            >View All Quotes &rarr;</a
          >
        </div>
      </div>
    </section>
    <div class="bottom-row-widgets">
      <section class="status-distribution-chart">
        <h2>Quotes by Status</h2>
        <div class="chart-placeholder" #chart></div>
      </section>
      <section class="performance-metrics">
        <div class="metric-card">
          <h3>Avg. Win Rate</h3>
          <p class="metric-value">68%</p>
        </div>
        <div class="metric-card">
          <h3>Avg. Lead Time</h3>
          <p class="metric-value">14 days</p>
        </div>
      </section>
    </div>
  </main>
</div>
